import _ from 'lodash';
import moment from 'moment';
import { setCookie } from '@bibliocommons/utils-browser';

import SearchApi from '../api/SearchApi';
import SearchConstants, { SEARCH_VIEW_COOKIE_NAME } from '../constants/SearchConstants';

const GROUPING_COOKIE = 'catalog_search_show_groupings';

// Actions /////////

function performSearch(query) {
  return {
    types: [
      SearchConstants.SEARCH_REQUEST,
      SearchConstants.SEARCH_SUCCESS,
      SearchConstants.SEARCH_FAILURE
    ],
    apiRequest: (state, apiClient) => SearchApi.fetchResults(query, apiClient)
  };
}

function addTitleSearch(searchQuery) {
  return {
    searchQuery,
    types: [
      SearchConstants.ADD_TITLE_SEARCH_REQUEST,
      SearchConstants.ADD_TITLE_SEARCH_SUCCESS,
      SearchConstants.ADD_TITLE_SEARCH_FAILURE
    ],
    apiRequest: (state, apiClient) => SearchApi.fetchResults({ ...searchQuery, view: 'medium' }, apiClient)
  };
}

function getSearchProbes(query, searchType) {
  return {
    types: [SearchConstants.SEARCH_PROBE_REQUEST, SearchConstants.SEARCH_PROBE_SUCCESS, SearchConstants.SEARCH_PROBE_FAILURE],
    apiRequest: (state, client) =>
      SearchApi.fetchSearchProbes(query, searchType, client)
  };
}

function expandField(fieldId, query) {
  return {
    types: [SearchConstants.EXPAND_FIELD_REQUEST, SearchConstants.EXPAND_FIELD_SUCCESS, SearchConstants.EXPAND_FIELD_FAILURE],
    apiRequest: (state, apiClient) => SearchApi.fetchAdditionalFilters(query, fieldId, apiClient)
  };
}

function toggleSearchView(view) {
  const expires = moment().add(10, 'years').toDate();
  setCookie(SEARCH_VIEW_COOKIE_NAME, view, { expires });
  return {
    type: SearchConstants.TOGGLE_SEARCH_VIEW,
    view
  };
}

function toggleShowGroupings(newState) {
  setCookie(GROUPING_COOKIE, newState || '');
  return {
    type: SearchConstants.TOGGLE_SHOW_GROUPINGS
  };
}

function receiveSearchResults(response) {
  return {
    type: SearchConstants.SEARCH_SUCCESS,
    payload: response.body
  };
}

function searchRequestFailed(payload) {
  return {
    type: SearchConstants.SEARCH_FAILURE,
    payload: {
      id: null,
      status: _.get(payload, 'status'),
      ..._.get(payload, 'response.body')
    }
  };
}

function getGroupSearchSummaries(metadataIds) {
  return {
    types: [SearchConstants.GROUP_SEARCH_SUMMARY_REQUEST, SearchConstants.GROUP_SEARCH_SUMMARY_SUCCESS, SearchConstants.GROUP_SEARCH_SUMMARY_FAILURE],
    apiRequest: (state, apiClient) => SearchApi.fetchGroupSearchSummaries(metadataIds, state.getIn(['library', 'libraryId']), apiClient)
  };
}

export default {
  expandField,
  getGroupSearchSummaries,
  getSearchProbes,
  addTitleSearch,
  receiveSearchResults,
  searchRequestFailed,
  toggleSearchView,
  toggleShowGroupings,
  performSearch
};



// WEBPACK FOOTER //
// ./app/actions/SearchActions.js